import React, { useContext } from 'react';

import { SortEnum } from 'src/queries/__global_generated__/globalTypes';

import { SortValues, Toolbar } from './Toolbar';
import { ProductListQueryContext } from './ProductListQueryProvider';

type ProductListToolbarProps = {
    currentFilters: React.ReactNode;
    totalSelections: number;
};

export function ProductListToolbar(props: ProductListToolbarProps) {
    const { pageInfo, setSortOrder, clearSort, loading, initialQueryVars } = useContext(ProductListQueryContext);

    const initial: SortValues | undefined = (() => {
        if (initialQueryVars.sortName === SortEnum.ASC) {
            return SortValues.NameAsc;
        }

        if (initialQueryVars.sortName === SortEnum.DESC) {
            return SortValues.NameDesc;
        }

        if (initialQueryVars.sortPrice === SortEnum.ASC) {
            return SortValues.PriceAsc;
        }

        if (initialQueryVars.sortPrice === SortEnum.DESC) {
            return SortValues.PriceDesc;
        }

        if (initialQueryVars.sortBestsellers === SortEnum.ASC) {
            return SortValues.Bestsellers;
        }

        return SortValues.Relevance;
    })();

    return (
        <Toolbar
            totalSelections={props.totalSelections}
            pageInfo={pageInfo}
            setSortOrder={setSortOrder}
            loading={loading}
            clearSort={clearSort}
            initial={initial}
            currentFilters={props.currentFilters}
        />
    );
}
